module.exports = __webpack_public_path__ + "img/bw1studio.a9ad339e.svg";